/**
 * @fileoverview ESM mirror of ../userHasPermission.js.
 *
 * AUTHZ-MATCHER-001: thin user-object-signature adapter over the canonical
 * `hasPermissionFor` (`@puffin-core/permissions`). No parallel matching
 * logic; multi-segment wildcard semantics. See ../userHasPermission.js.
 *
 * @module @puffin-core/cross-app-policy/userHasPermission
 */

import { hasPermissionFor } from '@puffin-core/permissions/has-permission-for';

function userHasPermission(user, permission) {
  if (!user || typeof user !== 'object') return false;
  return hasPermissionFor(user.permissions, permission);
}

export { userHasPermission };
